var _defs, _g, _g2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _g3, _path18, _path19, _path20, _g4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagForBritishVirginIslands(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-hidden": "true",
    role: "img",
    className: "iconify iconify--emojione",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "IconifyId17ecdb2904d178eab26123",
    gradientUnits: "userSpaceOnUse",
    x1: -2894.462,
    x2: -2893.46,
    gradientTransform: "matrix(-.5685 -.4287 -.1896 1.2856 -1429.15 -2349.261)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "red"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "IconifyId17ecdb2904d178eab26124",
    gradientUnits: "userSpaceOnUse",
    x1: -2893.675,
    x2: -2892.674,
    gradientTransform: "matrix(-.5688 -.4289 -.1897 1.2862 -1429.406 -2337.6)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "red"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "IconifyId17ecdb2904d178eab26125",
    gradientUnits: "userSpaceOnUse",
    x1: -2889.79,
    x2: -2888.789,
    gradientTransform: "matrix(-.5702 -.43 -.1901 1.2894 -1430.838 -2352.778)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "red"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "IconifyId17ecdb2904d178eab26126",
    gradientUnits: "userSpaceOnUse",
    x1: -2890.572,
    x2: -2889.572,
    gradientTransform: "matrix(-.5699 -.4298 -.1901 1.2888 -1430.426 -2345.343)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "red"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "IconifyId17ecdb2904d178eab26127",
    gradientUnits: "userSpaceOnUse",
    x1: -2884.43,
    x2: -2883.43,
    gradientTransform: "matrix(-.5722 -.4314 -.1908 1.2938 -1432.43 -2357.311)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "red"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "IconifyId17ecdb2904d178eab26128",
    gradientUnits: "userSpaceOnUse",
    x1: -2887.594,
    x2: -2886.593,
    gradientTransform: "matrix(-.571 -.4306 -.1904 1.2913 -1431.304 -2362.37)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "red"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "IconifyId17ecdb2904d178eab26129",
    gradientUnits: "userSpaceOnUse",
    x1: -2890.051,
    x2: -2889.051,
    gradientTransform: "matrix(-.5701 -.4299 -.1901 1.2892 -1441.875 -2358.836)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "red"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "IconifyId17ecdb2904d178eab26130",
    gradientUnits: "userSpaceOnUse",
    x1: -2891.519,
    x2: -2890.52,
    gradientTransform: "matrix(-.5696 -.4295 -.1899 1.288 -1441.695 -2340.727)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "red"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "IconifyId17ecdb2904d178eab26131",
    gradientUnits: "userSpaceOnUse",
    x1: -2892.84,
    x2: -2891.841,
    gradientTransform: "matrix(-.5691 -.4291 -.1898 1.2869 -1441.012 -2351.557)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "red"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "IconifyId17ecdb2904d178eab26132",
    gradientUnits: "userSpaceOnUse",
    x1: -2890.637,
    x2: -2889.638,
    gradientTransform: "matrix(-.5699 -.4297 -.19 1.2887 -1439.702 -2348.148)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "red"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "IconifyId17ecdb2904d178eab26133",
    gradientUnits: "userSpaceOnUse",
    x1: -2890.685,
    x2: -2889.685,
    gradientTransform: "matrix(-.5699 -.4297 -.19 1.2887 -1442.032 -2345.252)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "red"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "IconifyId17ecdb2904d178eab26134",
    gradientUnits: "userSpaceOnUse",
    x1: -2888.375,
    x2: -2887.377,
    gradientTransform: "matrix(-.5707 -.4304 -.1903 1.2906 -1442.509 -2354.917)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "red"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#2a5f9e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 2v30H2c0 16.6 13.4 30 30 30s30-13.4 30-30S48.6 2 32 2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 12h21v21H12z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.9 8.1V14h-7.3L26 32h6v-7.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 18.9H5c-1.9 4-3 8.4-3 13.1h12V13.9h-3v5"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ed4c5c",
    d: "M32 27.1L19 11h-6l17 21h2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9 5v6H11v3h21V2c-4.7 0-9.1 1.1-13.1 3z",
    fill: "#ffffff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32 5H18.9c-6 2.9-11 7.9-13.9 13.9V32h6V11h21V5z",
    fill: "#ed4c5c"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35 22.2l19.5-.1v17.3s.7 2.6-8.2 6.6c3.2-.3 6.6-3.7 6.6-3.7s1.4-1.8 2.1-.8c.7 1 1.3 1.5 1.8 1.9c.5.4.9 1.5.1 2.3c-.8.8-2 .9-2.3-.1c-.5.3-3.6 4-10 4.2c-6.5-.1-10-4.2-10-4.2s-.9 1.4-2.1.3c-1.2-1.4-.3-2.3-.3-2.3s1-.6 1.3-1c.5-.5.6-1.3 1.4-1.3c.9.1 1.3.8 1.3.8s3.3 3.4 6.8 3.9c-7.9-3.8-8.2-6.1-8.2-6.7l.2-17.1",
    fill: "#ffffff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5 22.6l18.6-.1v16.7c0 2.2-3.6 4.4-9.3 7.2c-5.9-3-9.3-4.9-9.3-7.2V22.6",
    fill: "#006129"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#IconifyId17ecdb2904d178eab26129)",
    d: "M37.6 25.1l.3-.6l-.4-1.1l-.2 1.7z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#IconifyId17ecdb2904d178eab26131)",
    d: "M37.6 28.3l.2-.6l-.3-1.1l-.3 1.7z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#IconifyId17ecdb2904d178eab26134)",
    d: "M37.6 31.5l.2-.7l-.4-1l-.2 1.7z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#IconifyId17ecdb2904d178eab26132)",
    d: "M39.6 34.9l.3-.6l-.4-1.1l-.2 1.7z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#IconifyId17ecdb2904d178eab26133)",
    d: "M37.3 37.7l.2-.6l-.3-1.1l-.3 1.7z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#IconifyId17ecdb2904d178eab26130)",
    d: "M37.3 41l.3-.6l-.4-1.1L37 41z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#IconifyId17ecdb2904d178eab26128)",
    d: "M49 25.1l.3-.6l-.4-1l-.2 1.6z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#IconifyId17ecdb2904d178eab26123)",
    d: "M48.9 28.3l.3-.6l-.4-1.1l-.2 1.7z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#IconifyId17ecdb2904d178eab26125)",
    d: "M48.8 31.5l.2-.6l-.3-1.1l-.3 1.7z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#IconifyId17ecdb2904d178eab26127)",
    d: "M48.9 34.7l.3-.6l-.4-1.1l-.2 1.7z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#IconifyId17ecdb2904d178eab26126)",
    d: "M48.9 37.9l.2-.7l-.3-1l-.3 1.7z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#IconifyId17ecdb2904d178eab26124)",
    d: "M48.9 41l.3-.6l-.4-1l-.2 1.6z"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffc6b5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.3 24.4c.1.4-.3.6-.3.8c0 .3.1.8.5.9c.6.2.1.8-.1 1.3c.6-.1 1.3-.1 1.9-.2c-.6-.9-.5-1.6-.5-2.6c0-.7-1.6-1-1.5-.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44 27.2c-.8.4-.7 1.6-.8 2.4c-.1.6-1 1.3-1.3 1.8c-.4.6-.9 1-.9 1.7c0 1.2.6.6.9-.1c.2-.5-.3-.6.3-1c.5-.4 1.4-.8 1.6-1.4c.3-.9.1-2.4.2-3.4"
  }))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M44.7 26.6c.4.8.8 0 1.3 0s.8.4 1.1.8c.5.6-.2.5-.5 1s.3 1.4 0 1.8c-.3.3 0 1.8-.1 2.3c0 .8 0 1.4.2 2.2c.4 1.8.7 3.3 1.2 5c.1.4 0 .9.1 1.3s.5.9-.2.9c-.3 0-.3.2-.5.1h-.7c.2 0-.9.4-.7.1c-.2.2.1.6-.5.4c-.2-.1-.1-.8-.5-.6c.1 0 .3.3.1.4c-.4.3-.5-.4-.9-.3c-.2 0-1.4.5-1.4 0c0-1.1.3-2 .3-3.2v-.5c0-.1-.3-.1-.3-.3c0-.5.1-1 .2-1.5c.1-1.1.3-2.2.5-3.2h-.2c-.2-.9.5-2.3.5-3.3c0-.7-.9-1.1-.3-1.8c.4-.5.5-1.4 1.3-1.6",
    fill: "#ffffff"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M47.2 27.8c.5 0 .6 3.2.4 3.6c-.4.6-.7 1.2-1 1.8c-.2.4 0 .9-.1 1.2c-.3.9-1.3-.1-.8-.8c.3-.4.5-1.1.7-1.6c.3-.6.7-1.2.4-1.9c-.4-.7-.7-2 .4-2.3",
    fill: "#ffc6b5"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M44.3 24.3c1-.1 2 2.6 2.3 1.5c.9-2.9-2.8-2.4-2.3-1.5",
    fill: "#9c5100"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    fill: "#f7c600"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.9 25.6c.4.6.3.1.3.7h1.7c0-.1-.1-.3-.2-.4c.7-.1.8-.9 1.4-1l-.4.3c-.4.5 0 .6 0 .2c0-.3.7-.2.6-.7c-.2-.3-.9.1-1.1.2c-.7.4-1.2-.7-1.6-.1c-.2.3-1.3.1-1.6.1c.3.5.5.6.9.7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.8 28.8c.4.6.3 0 .3.7h1.7c0-.1-.1-.3-.2-.4c.7-.1.8-.9 1.4-1l-.4.3c-.4.5 0 .6 0 .2c0-.3.7-.2.6-.7c-.2-.3-.9.1-1.1.2c-.7.4-1.2-.7-1.6-.1c-.2.3-1.3.1-1.6.1c.3.6.6.7.9.7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.8 32c.4.5.3.1.3.7h1.7c0-.1-.1-.3-.2-.4c.7-.1.8-.9 1.4-1l-.4.3c-.3.5 0 .6 0 .2c0-.3.7-.2.6-.7c-.2-.3-.9.1-1.1.2c-.7.4-1.2-.7-1.6-.1c-.2.3-1.3.1-1.6.1c.3.5.6.6.9.7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.1 34.5c-.4 0-.4.4-.9.4h-1.1c.1.2.1.3.4.4c.6.2.7.2.7.8h1.7c0-.1-.1-.3-.2-.4c.7-.1.8-.9 1.4-1l-.7.6c-.2.4.8-.3.9-.5c.3-.6-.9-.1-1 0c-.6.4-.7-.3-1.2-.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.6 38.2c.4.6.3.1.3.7h1.7c0-.1-.1-.3-.2-.4c.7-.1.8-.9 1.4-1l-.4.3c-.4.5 0 .6 0 .2c0-.3.7-.2.6-.7c-.2-.3-.9.1-1.1.2c-.7.4-1.2-.7-1.6-.1c-.2.3-1.3.1-1.6.1c.2.6.5.7.9.7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.5 41.2c-.3.2-.2.7-.1.5c.2-.3.2-.3.5-.5c1-.7-1-.1-1.1-.2c-.4 0-.5.1-.8-.2c-.5-.5-.4.2-.7.2c-.5.1-1.1 0-1.6 0c.1.2.1.3.4.4c.6.2.7.2.7.8h1.7c0-.1-.1-.3-.2-.4c.7-.1.8-.9 1.4-1c.3.1-.2.4-.2.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.3 25.6c.4.6.3 0 .3.7h1.7c0-.1-.1-.3-.2-.4c.7-.1.8-.9 1.4-1l-.4.3c-.4.5 0 .6 0 .2c0-.3.7-.2.6-.7c-.2-.4-.9.1-1.1.2c-.7.4-1.2-.7-1.6-.1c-.2.3-1.3.1-1.6.1c.2.6.5.7.9.7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.2 28.8c.4.6.3.1.3.7h1.7c0-.1-.1-.3-.2-.4c.7-.1.8-.9 1.4-1l-.4.3c-.4.5 0 .6 0 .2c0-.3.7-.2.6-.7c-.2-.3-.9.1-1.1.2c-.7.4-1.2-.7-1.6-.1c-.1.3-1.3.1-1.6.1c.2.6.5.6.9.7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49 32c.4.6.3.1.3.7H51c0-.1-.1-.3-.2-.4c.7-.1.8-.9 1.4-1l-.4.3c-.4.5 0 .6 0 .2c0-.3.7-.2.6-.7c-.2-.3-.9.1-1.1.2c-.7.4-1.2-.7-1.6-.1c-.2.3-1.3.1-1.6.1c.3.6.6.7.9.7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.7 34.5c-.2-.4-.9.2-1.1.2H51c-.3 0-.2-.4-.5-.4c-.4 0-.4.4-.9.4h-1.1c.1.2.1.3.4.4c.6.2.7.2.7.8h1.7c0-.1-.1-.3-.2-.4c.7-.1.8-.9 1.4-1c0 0-.9.6-.6.8c0 .1.9-.6.8-.8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 38.1c-.3.2-.2.7-.1.5c.2-.3.2-.3.5-.5c1-.7-1-.2-1.1-.2c-.4 0-.5.1-.8-.2c-.5-.5-.4.2-.7.2c-.5.1-1.1 0-1.6 0c.1.2.1.3.4.4c.6.2.7.2.7.8H51c0-.1-.1-.3-.2-.4c.7-.1.8-.9 1.4-1c.4.1-.2.4-.2.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.1 41.3c-.3.2-.2.7-.1.5c.2-.3.2-.3.5-.5c1-.7-1-.1-1.1-.1c-.4 0-.5.1-.8-.2c-.5-.5-.4.2-.7.2c-.5.1-1.1 0-1.6 0c.1.2.1.3.4.4c.6.2.7.2.7.8h1.7c0-.1-.1-.3-.2-.4c.7-.1.8-.9 1.4-1c.3 0-.2.3-.2.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.9 42.9c.5-.6.3-.9.3-.9l-1.2-.6l-.3.7l.2.4s.4 1.1 1 .4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.1 43c.2 0 1.4-.7 1.4-.7l-.1-.2l-.4-.3s-1.3.5-1.2.4c-.1.1.2.8.3.8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.9 44c-1-.4-1.8-2.1-2.4-2.2s-1.3.9-1.3.9s-3.3 3.8-8.5 3.9c-4.7.3-8.9-4.5-8.9-4.5s-.7-.6-1-.3c-.2.7-1.8 1.9-1.8 1.9s-.7.4-.6 1s1 1.2 1.2 1.3c.2 0 .7-.4.7-.4l.4-.4s4.6 4.4 10.1 4.3c5.3.2 10-4.3 10-4.3s.3-.1.4.5s1.1.2 1.3 0c.3-.2.9-.9.4-1.7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagForBritishVirginIslands);
export default __webpack_public_path__ + "static/media/flag-for-british-virgin-islands.63a3abe81654d33facf5ec5364d8b2bd.svg";
export { ForwardRef as ReactComponent };